import React from 'react';
import { Link } from 'react-router-dom';
import logoHUDigital from '../../../../assets/logo/logoHUDigital.svg';

import './Header.css';

export function Header() {
  return (
    <div className="headerLandingPage">
      <Link to="/" className="logoHUDigitalLink" aria-label="Voltar para a tela inicial">
        <img
          alt="logo hudigital"
          src={logoHUDigital}
          className="logoHUDigital"
        />
      </Link>
    </div>
  );
}
